import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.set";
import _toConsumableArray from "/app/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray";
import "core-js/modules/es6.string.iterator";
import _slicedToArray from "/app/node_modules/@babel/runtime-corejs2/helpers/slicedToArray";
import "core-js/modules/es6.promise";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime-corejs2/regenerator";
import "core-js/modules/es6.function.name";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/app/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import "core-js/modules/es6.regexp.split";
import _defineProperty from "/app/node_modules/@babel/runtime-corejs2/helpers/defineProperty";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import Vue from 'vue';
import { API_REQUEST } from '@/api';
import { getIndexedCollection, formTruthyFields, filterByUniqueField, lens } from '@/common/helpers';
var CACHE_REFRESH_INTERVAL = 30000;
var cache = {};
var cachedData = {
  workTypes: {},
  // by dep id
  allWorkerPositions: [],
  allWorkers: [],
  operationTypes: {},
  timetableTemplates: {},
  loadTemplates: {},
  mainWorkTypes: false
};
var cachedDataState = Object.keys(cachedData).reduce(function (acc, el) {
  return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, el, {
    isLoading: false,
    promises: []
  }));
}, {});
var cachedPromises = {};

function subscribeAnswer(apiMethod, params, updateStrictly) {
  var queryKey = apiMethod + '_' + JSON.stringify(params);

  if (!cachedPromises[queryKey] || updateStrictly) {
    cachedPromises[queryKey] = API_REQUEST(apiMethod, params);
  }

  return cachedPromises[queryKey];
}

function getDepartmentIdsForFetch(rootState, router) {
  var _router$currentRoute, _router$currentRoute$, _router$currentRoute2, _router$currentRoute3;

  var deps = rootState.queryMirrored.deps || (router === null || router === void 0 ? void 0 : (_router$currentRoute = router.currentRoute) === null || _router$currentRoute === void 0 ? void 0 : (_router$currentRoute$ = _router$currentRoute.query) === null || _router$currentRoute$ === void 0 ? void 0 : _router$currentRoute$.deps) || '';
  var internalOrOutsourcesIds = rootState.queryMirrored.internalOrOutsourcesIds || (router === null || router === void 0 ? void 0 : (_router$currentRoute2 = router.currentRoute) === null || _router$currentRoute2 === void 0 ? void 0 : (_router$currentRoute3 = _router$currentRoute2.query) === null || _router$currentRoute3 === void 0 ? void 0 : _router$currentRoute3.internalOrOutsourcesIds) || '';

  if (+rootState.queryMirrored.internalExchange === 1 || +rootState.queryMirrored.includeOutsource === 1) {
    return internalOrOutsourcesIds;
  }

  return deps;
}
/**
 * @param {(string|number)[]} ids
 * @param {import('vue-router').default} router
 */


var filterDepsFromQueryString = function filterDepsFromQueryString(ids, router) {
  var idsIndexed = ids.reduce(function (acc, id) {
    acc[String(id)] = id;
    return acc;
  }, {});
  var query = router.currentRoute.query;
  var newQuery;

  if (query.deps) {
    newQuery = _objectSpread(_objectSpread({}, query), {}, {
      deps: query.deps.split(',').filter(function (el) {
        return el && idsIndexed[el];
      }).join()
    });
  }

  if (query.internalOrOutsourcesIds) {
    var prevQuery = newQuery || query;
    newQuery = _objectSpread(_objectSpread({}, prevQuery), {}, {
      internalOrOutsourcesIds: prevQuery.internalOrOutsourcesIds.split(',').filter(function (el) {
        return el && idsIndexed[el];
      }).join()
    });
  }

  if (!newQuery) {
    return;
  }

  router.push({
    query: newQuery
  }).catch(function () {});
};

var state = {
  allDepartments: [],
  allDepsIncludeClients: [],
  allDepsIncludeOutsource: [],
  allDepartmentsById: {},
  allDepsIncludeClientsById: {},
  allDepsIncludeOutsourceById: {},
  depsIncludePossibleClients: [],
  positionsIncludeClients: [],
  workTypes: {},
  autoScheduling: {
    startDate: null,
    endDate: null
  },
  groups: []
};
var actions = {
  getMainWorkTypes: function getMainWorkTypes(_ref) {
    var _arguments = arguments,
        _this = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var rootState, _ref2, updateStrictly, ids, requestParams, mainWorkTypes, key;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              rootState = _ref.rootState;
              _ref2 = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : {}, updateStrictly = _ref2.updateStrictly;

              if (!(!cachedData.mainWorkTypes || updateStrictly)) {
                _context.next = 14;
                break;
              }

              ids = getDepartmentIdsForFetch(rootState, _this.$router);
              requestParams = {
                shop_id__in: ids,
                include_clients: true
              };
              key = JSON.stringify(requestParams);
              mainWorkTypes = cache[key];

              if (mainWorkTypes) {
                _context.next = 13;
                break;
              }

              _context.next = 10;
              return API_REQUEST('getWorkTypeName', requestParams);

            case 10:
              mainWorkTypes = _context.sent;
              cache[key] = mainWorkTypes;
              setTimeout(function () {
                delete cache[key];
              }, CACHE_REFRESH_INTERVAL);

            case 13:
              cachedData.mainWorkTypes = filterByUniqueField(mainWorkTypes[1], 'id').map(function (item) {
                return {
                  label: item['name'],
                  value: item['id']
                };
              });

            case 14:
              return _context.abrupt("return", cachedData.mainWorkTypes);

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  getWorkTypes: function getWorkTypes(_ref3) {
    var _arguments2 = arguments;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var commit, rootGetters, dispatch, _ref4, updateStrictly, byDepId, depIds, workTypes, params, workTypesResult, _workTypes, workTypeNames, allWorkTypes;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              commit = _ref3.commit, rootGetters = _ref3.rootGetters, dispatch = _ref3.dispatch;
              _ref4 = _arguments2.length > 1 && _arguments2[1] !== undefined ? _arguments2[1] : {
                updateStrictly: false
              }, updateStrictly = _ref4.updateStrictly, byDepId = _ref4.byDepId;
              // byDepId: 'all' or depId. 'all' means all work types by all deps
              depIds = typeof byDepId === 'undefined' ? rootGetters['queryMirrored/getDeps'] : [byDepId].flat();
              workTypes = cachedData.workTypes[byDepId];

              if (!(!workTypes || updateStrictly === true)) {
                _context2.next = 16;
                break;
              }

              params = byDepId === 'all' ? {} : {
                'shop_id__in': depIds
              };
              _context2.next = 8;
              return subscribeAnswer('getWorkTypes', params, updateStrictly);

            case 8:
              workTypesResult = _context2.sent;
              _workTypes = workTypesResult[1] || [];

              if (!(Object.keys(rootGetters['timetable/workTypeNamesIndexed']).length === 0)) {
                _context2.next = 13;
                break;
              }

              _context2.next = 13;
              return dispatch('timetable/fetchWorkTypeNames', {}, {
                root: true
              });

            case 13:
              workTypeNames = rootGetters['timetable/workTypeNamesIndexed'];
              allWorkTypes = _workTypes.sort(function (a, b) {
                return b.priority - a.priority;
              }).filter(function (el) {
                var _workTypeNames$el$wor;

                return (_workTypeNames$el$wor = workTypeNames[el['work_type_name_id']]) === null || _workTypeNames$el$wor === void 0 ? void 0 : _workTypeNames$el$wor.name;
              }).map(function (el) {
                return {
                  id: el['id'],
                  preliminaryCostPerHour: el['preliminary_cost_per_hour'],
                  availability_on_external_exchange: workTypeNames[el['work_type_name_id']].availability_on_external_exchange,
                  label: workTypeNames[el['work_type_name_id']].name,
                  nameId: el['work_type_name_id'],
                  shopId: el['shop_id']
                };
              });
              depIds.forEach(function (depId) {
                var wTypes = allWorkTypes.filter(function (el) {
                  return el.shopId === depId;
                });
                cachedData.workTypes[depId] = wTypes;
                commit('setWorkTypesById', {
                  depId: depId,
                  wTypes: wTypes
                });
              });

            case 16:
              return _context2.abrupt("return", cachedData.workTypes[depIds[depIds.length - 1]]);

            case 17:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  getOperationTypes: function getOperationTypes(_ref5) {
    var _arguments3 = arguments;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var rootGetters, _ref6, updateStrictly, depId, operationTypes, operationTypesResult;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              rootGetters = _ref5.rootGetters;
              _ref6 = _arguments3.length > 1 && _arguments3[1] !== undefined ? _arguments3[1] : {
                updateStrictly: false
              }, updateStrictly = _ref6.updateStrictly;
              depId = rootGetters['queryMirrored/getOneDep'];
              operationTypes = cachedData.operationTypes[depId];

              if (!(!operationTypes || updateStrictly === true)) {
                _context3.next = 9;
                break;
              }

              _context3.next = 7;
              return API_REQUEST('getOperationTypes', {
                'shop_id': depId
              });

            case 7:
              operationTypesResult = _context3.sent;
              cachedData.operationTypes[depId] = operationTypesResult === null || operationTypesResult === void 0 ? void 0 : operationTypesResult[1];

            case 9:
              return _context3.abrupt("return", cachedData.operationTypes[depId]);

            case 10:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  },
  getAllWorkerPositions: function getAllWorkerPositions(context) {
    var _arguments4 = arguments;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var _ref7, updateStrictly, includeOutsources, includeClients, includeAllowedSawhSettings, isForce, isLoading, isCached, apiOptions, _yield$API_REQUEST, _yield$API_REQUEST2, response;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _ref7 = _arguments4.length > 1 && _arguments4[1] !== undefined ? _arguments4[1] : {
                updateStrictly: false,
                includeOutsources: false,
                includeClients: false,
                includeAllowedSawhSettings: false,
                isForce: false
              }, updateStrictly = _ref7.updateStrictly, includeOutsources = _ref7.includeOutsources, includeClients = _ref7.includeClients, includeAllowedSawhSettings = _ref7.includeAllowedSawhSettings, isForce = _ref7.isForce;
              isLoading = cachedDataState.allWorkerPositions.isLoading;
              isCached = !!cachedData.allWorkerPositions.length && !isForce;

              if (!(isCached && !updateStrictly)) {
                _context4.next = 5;
                break;
              }

              return _context4.abrupt("return", cachedData.allWorkerPositions);

            case 5:
              if (!isLoading) {
                _context4.next = 7;
                break;
              }

              return _context4.abrupt("return", new Promise(function (resolve) {
                cachedDataState.allWorkerPositions.promises.push(resolve);
              }));

            case 7:
              apiOptions = {
                include_outsources: !!includeOutsources,
                include_clients: !!includeClients,
                include_allowed_sawh_settings: !!includeAllowedSawhSettings
              };
              cachedDataState.allWorkerPositions.isLoading = true;
              _context4.next = 11;
              return API_REQUEST('getAllWorkerPositions', formTruthyFields(apiOptions));

            case 11:
              _yield$API_REQUEST = _context4.sent;
              _yield$API_REQUEST2 = _slicedToArray(_yield$API_REQUEST, 2);
              response = _yield$API_REQUEST2[1];
              cachedDataState.allWorkerPositions.isLoading = false;
              cachedDataState.allWorkerPositions.promises.forEach(function (resolve) {
                return resolve(response);
              });
              cachedData.allWorkerPositions = response;
              return _context4.abrupt("return", response);

            case 18:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }))();
  },
  getPositionsIncludeClients: function getPositionsIncludeClients(_ref8) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      var state, commit, _yield$API_REQUEST3, _yield$API_REQUEST4, positionsRes, positions;

      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              state = _ref8.state, commit = _ref8.commit;

              if (!(state.positionsIncludeClients.length > 0)) {
                _context5.next = 3;
                break;
              }

              return _context5.abrupt("return", state.positionsIncludeClients);

            case 3:
              _context5.next = 5;
              return API_REQUEST('getAllWorkerPositions', {
                include_clients: true
              });

            case 5:
              _yield$API_REQUEST3 = _context5.sent;
              _yield$API_REQUEST4 = _slicedToArray(_yield$API_REQUEST3, 2);
              positionsRes = _yield$API_REQUEST4[1];
              positions = positionsRes.map(function (position) {
                return {
                  label: position.name,
                  value: position.id,
                  networkId: position.network_id
                };
              });
              commit('setPositionsInclClients', positions);
              return _context5.abrupt("return", positions);

            case 11:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }))();
  },
  getAllWorkers: function getAllWorkers(_ref9, _ref10) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
      var _cachedData$allWorker;

      var rootGetters, updateStrictly, usersRes;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              rootGetters = _ref9.rootGetters;
              updateStrictly = _ref10.updateStrictly;

              if (!(!((_cachedData$allWorker = cachedData.allWorkers) !== null && _cachedData$allWorker !== void 0 && _cachedData$allWorker.length) || updateStrictly)) {
                _context6.next = 7;
                break;
              }

              _context6.next = 5;
              return API_REQUEST('getUsers');

            case 5:
              usersRes = _context6.sent;
              cachedData.allWorkers = usersRes[1].map(function (user) {
                return {
                  id: user['id'],
                  fullname: "".concat(user['last_name'], " ").concat(user['first_name'], " ").concat(user['middle_name'] || '').trim(),
                  avatar: user['avatar'],
                  username: user.username
                };
              });

            case 7:
              return _context6.abrupt("return", cachedData.allWorkers);

            case 8:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }))();
  },
  getDepsIncludePossibleClients: function getDepsIncludePossibleClients(_ref11) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
      var state, commit, _yield$API_REQUEST5, _yield$API_REQUEST6, depsRes;

      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              state = _ref11.state, commit = _ref11.commit;

              if (!(state.depsIncludePossibleClients.length > 0)) {
                _context7.next = 3;
                break;
              }

              return _context7.abrupt("return", state.depsIncludePossibleClients);

            case 3:
              _context7.next = 5;
              return API_REQUEST('getAllDepartments', {
                include_possible_clients: true
              });

            case 5:
              _yield$API_REQUEST5 = _context7.sent;
              _yield$API_REQUEST6 = _slicedToArray(_yield$API_REQUEST5, 2);
              depsRes = _yield$API_REQUEST6[1];
              commit('setDepsIncludePossibleClients', depsRes);
              return _context7.abrupt("return", depsRes);

            case 10:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }))();
  },
  getAllDepartments: function getAllDepartments(_ref12, _ref13) {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
      var state, commit, updateStrictly, byId, includeClients, filter, _yield$Promise$all, _yield$Promise$all2, depsRes, depsIncludeClientsRes, depsIncludeOutsourceRes, allDepsIds, ubiqueIds, depsList;

      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              state = _ref12.state, commit = _ref12.commit;
              updateStrictly = _ref13.updateStrictly, byId = _ref13.byId, includeClients = _ref13.includeClients, filter = _ref13.filter;

              if (!(!state.allDepartments.length || updateStrictly)) {
                _context8.next = 16;
                break;
              }

              _context8.next = 5;
              return Promise.all([API_REQUEST('getAllDepartments'), API_REQUEST('getAllDepartments', {
                include_clients: true
              }), API_REQUEST('getAllDepartments', {
                include_outsources: true
              })]);

            case 5:
              _yield$Promise$all = _context8.sent;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 3);
              depsRes = _yield$Promise$all2[0];
              depsIncludeClientsRes = _yield$Promise$all2[1];
              depsIncludeOutsourceRes = _yield$Promise$all2[2];
              commit('setDepartments', {
                value: depsRes[1],
                name: 'allDepartments'
              });
              commit('setDepartments', {
                value: depsIncludeClientsRes[1],
                name: 'allDepsIncludeClients'
              });
              commit('setDepartments', {
                value: depsIncludeOutsourceRes[1],
                name: 'allDepsIncludeOutsource'
              });
              allDepsIds = lens([].concat(_toConsumableArray(depsRes[1]), _toConsumableArray(depsIncludeClientsRes[1]), _toConsumableArray(depsIncludeOutsourceRes[1])), 'id');
              ubiqueIds = _toConsumableArray(new Set(allDepsIds));
              filterDepsFromQueryString(ubiqueIds, _this2.$router);

            case 16:
              if (includeClients) {
                depsList = byId === true ? state.allDepsIncludeClientsById : state.allDepsIncludeClients;
              } else {
                depsList = byId === true ? state.allDepartmentsById : state.allDepartments;
              }

              if (Array.isArray(depsList) && filter) {
                depsList = depsList.filter(function (dep) {
                  var filterKeys = Object.keys(filter);
                  var isEveryKeyMatch = filterKeys.every(function (key) {
                    if (!dep[key]) {
                      dep[key] = '';
                    }

                    if (!filter[key]) {
                      filter[key] = '';
                    }

                    return dep[key].toLowerCase().includes(filter[key].toLowerCase());
                  });
                  return isEveryKeyMatch;
                });
              }

              return _context8.abrupt("return", depsList);

            case 19:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }))();
  },
  getAllDepartmentsExtended: function getAllDepartmentsExtended(_ref14) {
    var _arguments5 = arguments;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
      var state, commit, _ref15, _ref15$updateStrictly, updateStrictly, _ref15$byId, byId, _ref15$includeClients, includeClients, _ref15$includeOutsour, includeOutsources, _ref15$includePossibl, includePossibleClients, _ref15$filter, filter, apiOptions, _yield$API_REQUEST7, _yield$API_REQUEST8, res, depsList;

      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              state = _ref14.state, commit = _ref14.commit;
              _ref15 = _arguments5.length > 1 && _arguments5[1] !== undefined ? _arguments5[1] : {
                updateStrictly: false,
                byId: false,
                includeClients: false,
                includeOutsources: false,
                includePossibleClients: false,
                filter: null
              }, _ref15$updateStrictly = _ref15.updateStrictly, updateStrictly = _ref15$updateStrictly === void 0 ? false : _ref15$updateStrictly, _ref15$byId = _ref15.byId, byId = _ref15$byId === void 0 ? false : _ref15$byId, _ref15$includeClients = _ref15.includeClients, includeClients = _ref15$includeClients === void 0 ? false : _ref15$includeClients, _ref15$includeOutsour = _ref15.includeOutsources, includeOutsources = _ref15$includeOutsour === void 0 ? false : _ref15$includeOutsour, _ref15$includePossibl = _ref15.includePossibleClients, includePossibleClients = _ref15$includePossibl === void 0 ? false : _ref15$includePossibl, _ref15$filter = _ref15.filter, filter = _ref15$filter === void 0 ? null : _ref15$filter;

              if (!(!state.allDepartments.length || updateStrictly)) {
                _context9.next = 10;
                break;
              }

              apiOptions = {
                include_clients: !!includeClients,
                include_outsources: !!includeOutsources,
                include_possible_clients: !!includePossibleClients
              };
              _context9.next = 6;
              return API_REQUEST('getAllDepartments', formTruthyFields(apiOptions));

            case 6:
              _yield$API_REQUEST7 = _context9.sent;
              _yield$API_REQUEST8 = _slicedToArray(_yield$API_REQUEST7, 2);
              res = _yield$API_REQUEST8[1];
              commit('setDepartments', {
                value: res,
                name: 'allDepartments'
              });

            case 10:
              depsList = _toConsumableArray(state.allDepartments);

              if (Array.isArray(depsList) && filter) {
                depsList = depsList.filter(function (dep) {
                  var filterKeys = Object.keys(filter);
                  var isEveryKeyMatch = filterKeys.every(function (key) {
                    if (!dep[key]) {
                      dep[key] = '';
                    }

                    if (!filter[key]) {
                      filter[key] = '';
                    }

                    return dep[key].toLowerCase().includes(filter[key].toLowerCase());
                  });
                  return isEveryKeyMatch;
                });
              }

              return _context9.abrupt("return", byId ? getIndexedCollection(depsList) : depsList);

            case 13:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }))();
  },
  getTimetableTemplate: function getTimetableTemplate(context, ids) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
      var noCachedIds, list, res;
      return _regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              noCachedIds = [];
              list = [];
              ids.forEach(function (id) {
                if (cachedData.timetableTemplates[id]) {
                  list.push(cachedData.timetableTemplates[id]);
                } else {
                  noCachedIds.push(id);
                }
              });

              if (!noCachedIds.length) {
                _context10.next = 8;
                break;
              }

              _context10.next = 6;
              return API_REQUEST('getTimetableTemplate', {
                'id__in': noCachedIds
              });

            case 6:
              res = _context10.sent;

              if (res[1] !== false) {
                list.push.apply(list, _toConsumableArray(res[1]));
                res[1].forEach(function (template) {
                  cachedData.timetableTemplates[template.id] = template;
                });
              }

            case 8:
              return _context10.abrupt("return", list);

            case 9:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }))();
  },
  getLoadTemplate: function getLoadTemplate(context, ids) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
      var noCachedIds, list, res;
      return _regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              noCachedIds = [];
              list = [];
              ids.forEach(function (id) {
                if (cachedData.loadTemplates[id]) {
                  list.push(cachedData.loadTemplates[id]);
                } else {
                  noCachedIds.push(id);
                }
              });

              if (!noCachedIds.length) {
                _context11.next = 8;
                break;
              }

              _context11.next = 6;
              return API_REQUEST('getLoadTemplate', {
                'id__in': noCachedIds
              });

            case 6:
              res = _context11.sent;

              if (res[1] !== false) {
                list.push.apply(list, _toConsumableArray(res[1]));
                res[1].forEach(function (template) {
                  cachedData.loadTemplates[template.id] = template;
                });
              }

            case 8:
              return _context11.abrupt("return", list);

            case 9:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11);
    }))();
  },
  fetchGroups: function fetchGroups(_ref16) {
    var _arguments6 = arguments;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
      var commit, state, _ref17, _ref17$updateStrictly, updateStrictly, _yield$API_REQUEST9, _yield$API_REQUEST10, err, groups;

      return _regeneratorRuntime.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              commit = _ref16.commit, state = _ref16.state;
              _ref17 = _arguments6.length > 1 && _arguments6[1] !== undefined ? _arguments6[1] : {
                updateStrictly: false
              }, _ref17$updateStrictly = _ref17.updateStrictly, updateStrictly = _ref17$updateStrictly === void 0 ? false : _ref17$updateStrictly;
              _context12.prev = 2;

              if (!(!updateStrictly && state.groups.length)) {
                _context12.next = 5;
                break;
              }

              return _context12.abrupt("return");

            case 5:
              _context12.next = 7;
              return API_REQUEST('getGroups');

            case 7:
              _yield$API_REQUEST9 = _context12.sent;
              _yield$API_REQUEST10 = _slicedToArray(_yield$API_REQUEST9, 2);
              err = _yield$API_REQUEST10[0];
              groups = _yield$API_REQUEST10[1];

              if (!err) {
                _context12.next = 13;
                break;
              }

              throw err;

            case 13:
              commit('setValue', {
                entity: 'groups',
                value: groups
              });
              _context12.next = 20;
              break;

            case 16:
              _context12.prev = 16;
              _context12.t0 = _context12["catch"](2);
              console.log('Unable to fetch groups:');
              console.error(_context12.t0);

            case 20:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12, null, [[2, 16]]);
    }))();
  },
  fetchIPAddressList: function fetchIPAddressList(_ref18, _ref19) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
      var state, commit, shop_id, _yield$API_REQUEST11, _yield$API_REQUEST12, err, res;

      return _regeneratorRuntime.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              state = _ref18.state, commit = _ref18.commit;
              shop_id = _ref19.shop_id;
              _context13.next = 4;
              return API_REQUEST('getIPAddressList', {
                'shop_id': shop_id
              });

            case 4:
              _yield$API_REQUEST11 = _context13.sent;
              _yield$API_REQUEST12 = _slicedToArray(_yield$API_REQUEST11, 2);
              err = _yield$API_REQUEST12[0];
              res = _yield$API_REQUEST12[1];

              if (!err) {
                _context13.next = 10;
                break;
              }

              throw err;

            case 10:
              commit('setValue', {
                entity: 'ipAddressList',
                value: res
              });
              return _context13.abrupt("return", res);

            case 12:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13);
    }))();
  }
};
var mutations = {
  setDepartments: function setDepartments(state, _ref20) {
    var name = _ref20.name,
        _ref20$value = _ref20.value,
        value = _ref20$value === void 0 ? [] : _ref20$value;
    state[name] = value;
    state["".concat(name, "ById")] = value.reduce(function (acc, curr) {
      acc[String(curr.id)] = curr;
      return acc;
    }, {});
  },
  updateDepartment: function updateDepartment(state, value) {
    Vue.set(state.allDepartmentsById, value.id, value);
    var departmentList = Object.keys(state.allDepartmentsById).map(function (depId) {
      return state.allDepartmentsById[depId];
    });
    Vue.set(state, 'allDepartments', departmentList);
  },
  setPositionsInclClients: function setPositionsInclClients(state, positions) {
    state.positionsIncludeClients = positions;
  },
  setDepsIncludePossibleClients: function setDepsIncludePossibleClients(state, deps) {
    state.depsIncludePossibleClients = deps;
  },
  setWorkTypesById: function setWorkTypesById(state, _ref21) {
    var depId = _ref21.depId,
        wTypes = _ref21.wTypes;
    state.workTypes[depId] = wTypes;
  },
  setValue: function setValue(state, _ref22) {
    var entity = _ref22.entity,
        value = _ref22.value;
    state[entity] = value;
  }
};
var getters = {
  allDepartmentsById: function allDepartmentsById(state) {
    return state.allDepartmentsById;
  },
  allDepsIncludeClientsById: function allDepsIncludeClientsById(state) {
    return state.allDepsIncludeClientsById;
  },
  allDepsIncludeOutsourceById: function allDepsIncludeOutsourceById(state) {
    return state.allDepsIncludeOutsourceById;
  },
  groupsIndexed: function groupsIndexed(state) {
    return getIndexedCollection(state.groups, 'id');
  }
};
export default {
  namespaced: true,
  state: state,
  actions: actions,
  mutations: mutations,
  getters: getters
};